import { useGetPublicProductPlanV2Query } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.hooks';
import { buildFscPriceCatalogCart, buildFscSeatPrices } from 'pricing-pages-ui-components/fsc-configure/fscCatalogHelpers';
import { getFscZeroCreditOption } from 'pricing-pages-ui-components/fsc-configure/fscCreditPacksHelpers';
import Raven from 'raven-js';
import { useCallback, useMemo } from 'react';
import { DEFAULT_CHIRP_TIMEOUT } from '../../constants/chirpDefaults';
import { isAbortedQueryError } from '../../utils/isAbortedQueryError';
export function useFscPriceCatalog({
  catalog,
  selectedTier,
  browserLocale,
  preferredCountryCode,
  currencyCode,
  term
}) {
  const productCart = useMemo(() => buildFscPriceCatalogCart(catalog, selectedTier).map(({
    productApiName,
    quantity
  }) => ({
    productApiName,
    skuQuantity: quantity
  })), [catalog, selectedTier]);
  const handleError = useCallback(error => {
    if (isAbortedQueryError(error)) return;
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-fsc-configure-price-catalog'],
      extra: {
        currencyCode,
        preferredCountryCode,
        selectedTier
      }
    });
  }, [currencyCode, preferredCountryCode, selectedTier]);
  const {
    data,
    loading,
    error
  } = useGetPublicProductPlanV2Query({
    variables: {
      productCart,
      browserLocale,
      preferredCountryCode,
      currencyCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    },
    onError: handleError
  });
  const productPlanOptions = useMemo(() => {
    var _data$productPlanOpti;
    return (_data$productPlanOpti = data === null || data === void 0 ? void 0 : data.productPlanOptions) !== null && _data$productPlanOpti !== void 0 ? _data$productPlanOpti : [];
  }, [data]);
  const pricesByApiName = useMemo(() => {
    const zeroOption = getFscZeroCreditOption(productPlanOptions);
    return zeroOption ? buildFscSeatPrices(zeroOption, term) : new Map();
  }, [productPlanOptions, term]);
  return {
    pricesByApiName,
    productPlanOptions,
    isPriceLoading: loading,
    error
  };
}